/**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/* eslint-disable import/prefer-default-export */
/**
 * Color scheme for form elements.
 */
export enum FORM_ELEMENT_COLOR_SCHEME {
  /**
   * Regular color scheme.
   */
  REGULAR = '',

  /**
   * Light color scheme.
   */
  LIGHT = 'light',
}
